import { render, staticRenderFns } from "./HazardResolution.vue?vue&type=template&id=24ff9e31"
import script from "./HazardResolution.vue?vue&type=script&lang=js"
export * from "./HazardResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports